import "./PrepaidCreditsReport.scss";

import React from "react";
import usesFeatures from "usesFeatures";

import Table from "Table";
import Header from "Header";
import Paginate from "Paginate";
import BaseReport from "VenueAdmin/shared/BaseReport";
import ReportFilters from "VenueAdmin/shared/ReportFilters";

class PrepaidCreditsReport extends BaseReport {
  getBaseEndpoint() {
    return "venue_admin/prepaid_credits_report";
  }

  getSearchEndpoint() {
    return "venue_admin/prepaid_credits_report/search_prepaid_credits";
  }

  getDownloadFilename() {
    return `Prepaid Credits Report - ${new Date().toISOString().split('T')[0]}.csv`;
  }

  getItemIdsParamName() {
    return "prepaid_credit_ids";
  }

  getItemsDataKey() {
    return "prepaidCredits";
  }

  // Override to transform prepaid credit data for autocomplete
  searchItems = (term) => {
    if (term.length < 2) {
      this.setState({ itemSuggestions: [], showSuggestions: false });
      return;
    }

    const request = require("request").default;
    request.get(`/${this.getSearchEndpoint()}?term=${encodeURIComponent(term)}`)
      .then(({ data }) => {
        const suggestions = data.prepaidCredits
          .map(item => ({ ...item, name: item.code })) // Add name field for display
          .filter(item => !this.state.selectedItems.find(si => si.id === item.id));
        this.setState({ itemSuggestions: suggestions, showSuggestions: true });
      });
  };

  itemFormatters = () => ({
    storeName: (item) => item.storeName,
    code: (item) => item.code,
    initialBalance: (item) => item.initialBalance,
    currentBalance: (item) => item.currentBalance,
    averageAmount: (item) => item.averageAmount,
    orderCount: (item) => item.orderCount,
    total: (item) => item.total,
  });

  renderFilters() {
    const { filters, selectedItems, itemSearch, itemSuggestions, showSuggestions } = this.state;
    const stores = this.props.stores || [];

    return (
      <ReportFilters
        filters={filters}
        stores={stores}
        selectedItems={selectedItems}
        itemSearch={itemSearch}
        itemSuggestions={itemSuggestions}
        showSuggestions={showSuggestions}
        itemLabel="Prepaid Credits"
        itemPlaceholder="Search prepaid credits..."
        onFilterChange={this.handleFilterChange}
        onItemSearchChange={this.handleItemSearchChange}
        onItemSelect={this.selectItem}
        onItemRemove={this.removeItem}
        onClearAllItems={this.clearAllItems}
        onFocus={() => itemSuggestions.length > 0 && this.setState({ showSuggestions: true })}
        onBlur={() => setTimeout(() => this.setState({ showSuggestions: false }), 200)}
      />
    );
  }

  render() {
    if (!this.props.dataFetched) return false;

    return (
      <div className="PrepaidCreditsReport">
        <Header text="Prepaid Credits Report" actions={true}>
          <button
            className="button is-primary"
            onClick={this.handleDownload}
            disabled={this.state.downloading}
          >
            {this.state.downloading ? 'Downloading...' : 'Download CSV'}
          </button>
        </Header>

        {this.renderFilters()}

        <div className="box">
          <Table
            rows={this.props.pageData}
            headers={HEADERS}
            formatters={this.itemFormatters()}
          />
          <Paginate pagy={this.props.pagy} onPageChange={this.handlePageChange} />

          <div className="has-text-right mt-4">
            <strong>Grand Total: {this.props.grandTotal}</strong>
          </div>
        </div>
      </div>
    );
  }
}

const HEADERS = {
  code: "Code",
  initialBalance: "Initial Balance",
  currentBalance: "Current Balance",
  storeName: "Store",
  averageAmount: "Avg Applied",
  orderCount: "Orders",
  total: "Total Applied",
};

export default usesFeatures(["data"], PrepaidCreditsReport);
